import createClient, { type Client } from 'openapi-fetch'
import { getBuildShortSha } from '@bugseq-site/shared/src/env'

export function createApiClient<Paths extends {}> (baseUrl: string): Client<Paths> {
  const client = createClient<Paths>({ baseUrl })
  client.use({
    onRequest ({ request }) {
      request.headers.set('x-bugseq-frontend-version', getBuildShortSha())
      return request
    }
  })
  return client
}
